import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface ButtonLinkProps {
  children: ReactNode;
  to: string;
  variant?: "primary" | "quiet";
}

export function ButtonLink({ children, to, variant = "primary" }: ButtonLinkProps) {
  return (
    <Link className={`button-link button-link--${variant}`} to={to}>
      {children}
    </Link>
  );
}
